"use client";

import type { ComponentProps, FunctionComponent } from "react";
import cn from "~/lib/class-names";

const Label: FunctionComponent<ComponentProps<"label">> = ({
  className,
  htmlFor,
  ...props
}) => (
  <label
    data-slot="label"
    className={cn(
      "flex items-center gap-2 text-sm leading-none font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50",
      className,
    )}
    htmlFor={htmlFor}
    {...props}
  />
);

export default Label;
